import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchFilter' })
export class SearchFilterPipe implements PipeTransform {

	transform(items: any[], searchWord: string, ...searchProperties: string []): any[] {
    const canNotFilterItems = !items || !searchWord || !searchProperties.length;
		if (canNotFilterItems) {
			return items;
		}
		searchWord = searchWord.toLowerCase();
    const hasMultipleProperties = searchProperties.length > 1;
    return hasMultipleProperties ? this.searchByMultipleProperties(items, searchProperties, searchWord)
    : this.searchBySingleProperty(items, searchProperties, searchWord);
	}

  searchByMultipleProperties(items: any[], searchProperties: string [], searchWord: string){
    return items.filter(item => {
      return searchProperties.some(property => item[property].toLowerCase().includes(searchWord));
    });
  }

  searchBySingleProperty(items: any[], searchProperties: string [], searchWord: string){
    const searchProperty = searchProperties[0];
    return items.filter(item => {
      return item[`${searchProperty}`].toLowerCase().includes(searchWord);
    });
  }

}
